import MWingBlank from './src';
import './style';

MWingBlank.install = Vue => {
  Vue.component('MWingBlank', MWingBlank);
};

export default MWingBlank;
